module.exports = __webpack_public_path__ + "img/9788964360682.6c46d07b.jpg";